module.exports = __webpack_public_path__ + "static/media/icon_bbobi.eb8cad5f.svg";